import { isUndefined } from '@aloft/toolkit-shared';

import { Typography } from '../../../summary/components/Typography.tsx';
import { SummarySection } from '../SummarySection.tsx';
import { TitleAndExportToggleLockup } from '../TitleAndExportToggleLockup.tsx';
import { Tkv2PairedCostSummaryInterfaceV2 } from '../types.ts';

export const AdjustmentBreakdownDepreciatedCostMainDwellingBath = (
  props: Tkv2PairedCostSummaryInterfaceV2,
) => {
  const { fullBathCost, halfBathCost } =
    props.results.subject?.features?.bathAboveGrade?.costsDepreciated ?? {};

  if (isUndefined(fullBathCost) && isUndefined(halfBathCost)) {
    return null;
  }

  const fullBathAdjustmentString = `${fullBathCost?.toString(true)}/full bath`;
  const halfBathAdjustmentString = `${halfBathCost?.toString(true)}/half bath`;
  const bathAdjustmentString = [fullBathAdjustmentString, halfBathAdjustmentString].join(' and ');

  return (
    <SummarySection marginBottom="2rem">
      <TitleAndExportToggleLockup
        {...props}
        title="Bath"
        id="isDepreciatedCostMainDwellingGLAInExport"
        variant="h3"
      />
      <Typography variant="body1">
        {`The Bath adjustment of ${bathAdjustmentString} is based on the depreciated cost per
                bath fixture for a dwelling of the subject's quality and condition.`}
      </Typography>
    </SummarySection>
  );
};
